import axios from "axios";
// import decode from "jwt-decode";
import store from "@/store/index";
import Cookies from "js-cookie";
const instance = axios.create();
// instance.defaults.baseURL = process.env.VUE_APP_MY_TRIP_API_URL;

var url = process.env.VUE_APP_API_URL_HOST
var SVDAPIURL = process.env.VUE_APP_SVD_API_URL_HOST

instance.defaults.headers["X-Requested-With"] = "XMLHttpRequest";
instance.defaults.headers.common['Authorization']= `Bearer ${Cookies.get('access_token')}`;
instance.defaults.headers.common['Content-Type']= 'application/json';
instance.interceptors.request.use(
  response => {
    store.commit("auth/IS_LOADING", true);

    return response;
  },
  error => Promise.reject(error)
);

instance.interceptors.response.use(
  response => {
    store.commit("auth/IS_LOADING", false);

    return response;
  },
  async error => {
    console.log(error);
    const status = error.response ? error.response.status : null;
    const message = error.response?.data ? (error.response?.data?.message || "failed") : "failed";
    if (status === 401 && message.includes("expired")) {
      let refreshToken = await store.dispatch("auth/refreshTokenReq");
      if (refreshToken.status) {
        // const token = store.state.auth.accessToken.token;
        // error.config.headers["Authorization"] = `Bearer ${token}`;
        error.config.headers["Authorization"] = `Bearer ${Cookies.get('access_token')}`;
        // error.config.baseURL = undefined;

        // return Promise.resolve(axios.request(error.config));
        return instance(error.config);
      }
    } else if (status === 401 && message.includes("Not allowed")) {
      Cookies.set('loggedIn', 'false')
      store.dispatch("auth/logout")
        .then(() => {
          store.dispatch("auth/resetInitialPath", JSON.parse(localStorage.getItem("InitialPath")))
          store.dispatch("auth/resetIconSetting", JSON.parse(localStorage.getItem("IconSetting")))
          localStorage.setItem('sessionDialog', 'true')
          location.reload()
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      const error_popup = {
        showPopup: true,
        errorMessage: message
      }
      store.commit("auth/SET_ERROR_POPUP", error_popup);
    }
    store.commit("auth/IS_LOADING", false);
    return Promise.reject(error);
  }
);

export default class APIMyTrip {
  static get(path, options = {}) {
    return instance.get(url + path, { ...options });
  }

  static svdGet(path, options = {}) {
    return instance.get(SVDAPIURL + path, { ...options });
  }

  static post(path, data = {}, options = {}) {
    return instance.post(url + path, data, { ...options });
  }

  static setToken() {
    instance.defaults.headers.common['Authorization']= `Bearer ${Cookies.get('access_token')}`;
  }

}
